import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/** 10 pixels of margin */
export const isOverflowingRight = (element: HTMLDivElement) => element.scrollWidth > element.offsetWidth + element.scrollLeft + 10;
export const isScrolledToRight = (element: HTMLDivElement) => element.scrollLeft;

export const isOverflowingLeft = (element: HTMLDivElement) => element.scrollLeft > 0;
export const isScrolledToLeft = (element: HTMLDivElement) => element.scrollLeft === 0;

export const isOverflowingBottom = (element: HTMLDivElement) => element.scrollHeight > element.offsetHeight + element.scrollTop + 10;
export const isScrolledToBottom = (element: HTMLDivElement) => element.scrollTop;

@Directive({
  selector: '[appScrollWatcher]',
})
export class ScrollWatcherDirective implements OnInit, OnDestroy, AfterViewInit {
  private readonly destroy$ = new Subject();

  constructor(
    private readonly el: ElementRef,
    private readonly zone: NgZone,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.changeDetectorRef.detectChanges(), 100);
  }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      fromEvent(this.el.nativeElement, 'scroll')
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.zone.run(() => {}));
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
